import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, ControlLabel, Input, Form, Message } from 'rsuite'
import {
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'

export default function ProjectNameForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  reservedWords,
  setReservedWords = () => {},
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [textLengthProNameTH, setTextLengthProNameTH] = useState(
    schema?.projectNameTH?.value?.length || 0
  )
  const [textLengthProNameEN, setTextLengthProNameEN] = useState(
    schema?.projectNameEN?.value?.length || 0
  )
  // const [reservedWords, setReservedWords] = useState()

  useEffect(() => {
    onChangeProjetName(schema?.projectNameTH?.value)
  }, [])

  const placeholderFormTemplate = (hint, formTemplate) => {
    let str = ''

    if (hint) {
      str = hint
    } else {
      switch (formTemplate) {
        case 1:
        case 2:
        case 3:
        case 5:
        case 6:
        case 7:
          str = 'ระบุชื่อชุมชน'
          break
        case 4:
          str = 'ระบุชื่อโรงเรียน'
          break
        case 8:
          str = 'ระบุส่งเสริมกิจกรรมทางกายด้วยศิลปวัฒนธรรมไทย'
          break
      }
    }

    return str
  }

  const onChangeProjetName = (value) => {
    let reservedWords = ''
    schema?.reservedWords?.forEach((item) => {
      if (value?.includes(item)) {
        if (reservedWords) {
          reservedWords += ',' + item
        } else {
          reservedWords = item
        }
      }
    })

    setReservedWords(reservedWords)
    setTextLengthProNameTH(value?.length || 0)
  }

  return (
    <>
      <Form>
        <Panel>
          <Row>
            {schema.description && (
              <Col style={{ marginBottom: 10 }}>
                <CustomAlertMessageInfo contents={schema.description} />
              </Col>
            )}

            {schema.reservedWords && (
              <Col>
                <Message
                  showIcon
                  type="warning"
                  description={'คำต้องห้ามในชื่อโครงการ : ' + schema.reservedWords.join(',')}
                  style={{ marginBottom: 10 }}
                />
              </Col>
            )}

            {schema.projectNameTH && (
              <Col>
                {reservedWords && (
                  <Message
                    showIcon
                    type="error"
                    description={'พบคำต้องห้ามไม่อนุญาตให้ใช้เป็นชื่อโครงการ : ' + reservedWords}
                    style={{ marginBottom: 10 }}
                  />
                )}

                <ErrorMessage error={errors[schema.projectNameTH.name]} />
                <ControlLabel>
                  {requiredFiled(schema.projectNameTH.validators, schema.projectNameTH.label)}
                </ControlLabel>
                <Input
                  name={schema.projectNameTH.name}
                  defaultValue={schema.projectNameTH.value}
                  placeholder={schema.projectNameTH.hint || `ระบุ${schema.projectNameTH.label}`}
                  inputRef={register(isValidators(schema.projectNameTH.validators))}
                  maxLength={getMaxLengthData(schema.projectNameTH.validators)?.value || 1000}
                  onChange={(value) => {
                    onChangeProjetName(value)
                  }}
                />
                <ShowLimitLength
                  textLength={textLengthProNameTH}
                  maxLength={getMaxLengthData(schema.projectNameTH.validators)?.value || 1000}
                />
              </Col>
            )}

            {schema.projectNameEN && (
              <Col style={{ marginTop: 10 }}>
                <ErrorMessage error={errors[schema.projectNameEN.name]} />
                <ControlLabel>
                  {requiredFiled(schema.projectNameEN.validators, schema.projectNameEN.label)}
                </ControlLabel>
                <Input
                  name={schema.projectNameEN.name}
                  defaultValue={schema.projectNameEN.value}
                  placeholder={schema.projectNameEN.hint || `ระบุ${schema.projectNameEN.label}`}
                  inputRef={register(isValidators(schema.projectNameEN.validators))}
                  maxLength={getMaxLengthData(schema.projectNameEN.validators)?.value || 250}
                  onChange={(e) => {
                    setTextLengthProNameEN(e.length)
                  }}
                />
                <ShowLimitLength
                  textLength={textLengthProNameEN}
                  maxLength={getMaxLengthData(schema.projectNameEN.validators)?.value || 250}
                />
              </Col>
            )}

            {schema.projectVar1 && (
              <Col style={{ marginTop: 10 }}>
                <ErrorMessage error={errors[schema.projectVar1.name]} />
                <ControlLabel>
                  {requiredFiled(schema.projectVar1.validators, schema.projectVar1.label)}
                </ControlLabel>
                <Input
                  name={schema.projectVar1.name}
                  defaultValue={schema.projectVar1.value}
                  placeholder={placeholderFormTemplate(schema.hint, schema.formTemplate)}
                  inputRef={register(isValidators(schema.projectVar1.validators))}
                />
              </Col>
            )}

            {schema.projectVar2 && (
              <Col style={{ marginTop: 10 }}>
                <ErrorMessage error={errors[schema.projectVar2.name]} />
                <ControlLabel>
                  {requiredFiled(schema.projectVar2.validators, schema.projectVar2.label)}
                </ControlLabel>
                <Input
                  name={schema.projectVar2.name}
                  defaultValue={schema.projectVar2.value}
                  placeholder={schema.projectVar2.hint || `ระบุ${schema.projectVar2.label}`}
                  inputRef={register(isValidators(schema.projectVar2.validators))}
                />
              </Col>
            )}

            {schema.projectVar3 && (
              <Col style={{ marginTop: 10 }}>
                <ErrorMessage error={errors[schema.projectVar3.name]} />
                <ControlLabel>
                  {requiredFiled(schema.projectVar3.validators, schema.projectVar3.label)}
                </ControlLabel>
                <Input
                  name={schema.projectVar3.name}
                  defaultValue={schema.projectVar3.value}
                  placeholder={schema.projectVar3.hint || `ระบุ${schema.projectVar3.label}`}
                  inputRef={register(isValidators(schema.projectVar3.validators))}
                />
              </Col>
            )}

            {schema.projectVar4 && (
              <Col style={{ marginTop: 10 }}>
                <ErrorMessage error={errors[schema.projectVar4.name]} />
                <ControlLabel>
                  {requiredFiled(schema.projectVar4.validators, schema.projectVar4.label)}
                </ControlLabel>
                <Input
                  name={schema.projectVar4.name}
                  defaultValue={schema.projectVar4.value}
                  placeholder={schema.projectVar4.hint || `ระบุ${schema.projectVar4.label}`}
                  inputRef={register(isValidators(schema.projectVar4.validators))}
                />
              </Col>
            )}

            {schema.projectVar5 && (
              <Col style={{ marginTop: 10 }}>
                <ErrorMessage error={errors[schema.projectVar5.name]} />
                <ControlLabel>
                  {requiredFiled(schema.projectVar5.validators, schema.projectVar5.label)}
                </ControlLabel>
                <Input
                  name={schema.projectVar5.name}
                  defaultValue={schema.projectVar5.value}
                  placeholder={schema.projectVar5.hint || `ระบุ${schema.projectVar5.label}`}
                  inputRef={register(isValidators(schema.projectVar5.validators))}
                />
              </Col>
            )}
          </Row>
        </Panel>
      </Form>
    </>
  )
}
